import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/fastigheter',
      component: () => import('@/views/Home'),
      children: [
        {
          path: 'a/:id',
          component: () => import('@/views/Alarm')
        },
        {
          path: 'fastigheter',
          component: () => import('@/views/RealEstates')
        },
        {
          path: 'fastighet/:id',
          redirect: '/fastighet/:id/system',
          component: () => import('@/views/RealEstate'),
          props: true,
          beforeEnter (to, from, next) {
            const previousPath = from.fullPath
            to.params.previousPath = previousPath
            next()
          },
          children: [
            {
              path: 'kategori',
              component: () => import('@/components/GroupedAlarmList')
            },
            {
              path: 'system',
              component: () => import('@/components/GroupedAlarmList')
            },
            {
              path: 'larm',
              component: () => import('@/components/AlarmList')
            }
          ]
        },
        {
          path: 'fastighet/:id/kategori/:categoryID',
          component: () => import('@/views/RealEstateCategory'),
          props: true,
          beforeEnter (to, from, next) {
            to.params.previousPath = from.fullPath
            next()
          }
        },
        {
          path: 'fastighet/:id/system/:systemID',
          component: () => import('@/views/RealEstateSystem')
          // beforeEnter (to, from, next) {
          //   console.log(to.params.systemID)
          //   console.log(to.params.id)
          //   next()
          // }
        },
        {
          path: 'fastighet/:id/alla',
          component: () => import('@/views/RealEstateAll')
        },
        {
          path: '/felanmälningar',
          component: () => import('@/views/BugReports')
        },
        {
          path: '/okategoriserat',
          component: () => import('@/views/Uncategorised'),
          beforeEnter (to, from, next) {
            store.dispatch('blocks/getBlocksAndAlarms').then(() => {
              next()
            })
          }
        },
        {
          path: '/anvandarstatistik',
          component: () => import('@/views/UserStatistics'),
          beforeEnter (to, from, next) {
            store.dispatch('statistics/fetchUserStatistics').then(() => {
              next()
            })
          }
        },
        {
          path: '/systemstatus',
          component: () => import('@/views/SystemStatus'),
          beforeEnter: (to, from, next) => {
            store.dispatch('status/fetchSystemStatusRaw').then(() => {
              next()
            })
          }
        }
      ]
    },
    {
      path: '/login',
      component: () => import('@/views/Login')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js